module.exports = __webpack_public_path__ + "img/img9.4a22c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img9.png
// module id = 231
// module chunks = 0